<template>
    <div class="w-full space-y-3">
        <slot name="title"></slot>
      <div class="w-full flex gap-3 justify-between">
        <div class="w-full flex gap-3">
          <Link :href="route('frontend.organisations.create', 'client')"
                class="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase bg-amaze-coral focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            <svg class="-ml-0.5 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            Add New Client
          </Link>
          <Link :href="route('frontend.organisations.create', 'supplier')"
                class="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase bg-amaze-coral focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            <svg class="-ml-0.5 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            Add New Supplier
          </Link>
          <button @click="openCreateGroup()"
                  class="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">
            <svg class="-ml-0.5 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            Create New Group
          </button>
        </div>
        <div class="w-full flex justify-end justify-content-end align-items-end">
          <slot name="searchfilter"></slot>
        </div>
      </div>
        <div class="flex justify-between">
            <OrganisationTabs/>
            <div class="w-1/2 flex gap-3 justify-between justify-end">
                <div class="flex gap-1 w-full items-center">
                    <slot name="filters"></slot>
                </div>
            </div>
        </div>
    </div>

    <div>
        <slot :key="$page.url"></slot>
    </div>

    <CreateOrganisationGroup ref="createOrganisationGroupSlideout"/>
</template>

<script>
import Authenticated from "@/Layouts/Authenticated.vue";
import SearchFilter from "@/Components/SearchFilter.vue";
import {ref} from "vue";
import {useForm} from "@inertiajs/vue3";
import OrganisationTabs from "@/Components/OrganisationTabs";
import debounce from "lodash/debounce";
import pickBy from "lodash/pickBy";
import {Link} from "@inertiajs/vue3";
import CreateOrganisationGroup from "@/Components/SlideOuts/CreateOrganisationGroup";
import {mapActions} from "vuex";

export default {
    layout: Authenticated,
    components: {
        CreateOrganisationGroup,
        SearchFilter,
        OrganisationTabs,
        Link
    },
    methods: {
        ...mapActions('organisations', [
            'openCreateGroup'
        ]),
    },
    watch: {
        form: {
            deep: true,
            handler: debounce(function () {
                this.$inertia.get(route('frontend.organisations.clients'), pickBy(this.form), {preserveState: true})
            }, 500),
        },
    },
}
</script>
